"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var react_hooks_1 = require("@apollo/react-hooks");
var apollo_boost_1 = require("apollo-boost");
var apollo_link_context_1 = require("apollo-link-context");
var apollo_link_error_1 = require("apollo-link-error");
var promise_to_observable_1 = require("../utils/promise-to-observable");
var ApolloClientProvider = function (_a) {
    var children = _a.children, graphqlApiUrl = _a.graphqlApiUrl, getIdToken = _a.getIdToken;
    var httpLink = new apollo_boost_1.HttpLink({
        uri: graphqlApiUrl
    });
    var authLink = apollo_link_context_1.setContext(function (_, _a) {
        var headers = _a.headers;
        return getIdToken().then(function (idToken) { return ({
            headers: idToken ? __assign(__assign({}, headers), { authorization: "Bearer " + idToken }) : headers
        }); });
    });
    var errorLink = apollo_link_error_1.onError(function (_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, operation = _a.operation, forward = _a.forward;
        if (graphQLErrors)
            graphQLErrors.map(function (_a) {
                var extensions = _a.extensions;
                return __awaiter(void 0, void 0, void 0, function () {
                    var oldHeaders_1;
                    return __generator(this, function (_b) {
                        switch (extensions === null || extensions === void 0 ? void 0 : extensions.code) {
                            case 'invalid-jwt':
                                console.log('refetching jwt');
                                oldHeaders_1 = operation.getContext().headers;
                                return [2, promise_to_observable_1.promiseToObservable(getIdToken()).flatMap(function (newIdToken) {
                                        operation.setContext({
                                            headers: __assign(__assign({}, oldHeaders_1), { authorization: "Bearer " + newIdToken })
                                        });
                                        return forward(operation);
                                    })];
                            case 'data-exception':
                            case 'validation-failed':
                            default:
                                console.log(extensions === null || extensions === void 0 ? void 0 : extensions.code);
                        }
                        return [2, null];
                    });
                });
            });
        if (networkError) {
            console.log("[Network error]: " + networkError);
        }
    });
    var client = new apollo_boost_1.ApolloClient({
        link: errorLink.concat(authLink.concat(httpLink)),
        cache: new apollo_boost_1.InMemoryCache()
    });
    return React.createElement(react_hooks_1.ApolloProvider, { client: client }, children);
};
exports["default"] = ApolloClientProvider;
//# sourceMappingURL=apollo-client-provider.js.map